module.exports = __webpack_public_path__ + "img/galeria-florestal-1.e558b100.jpg";